import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import styled from "styled-components";

const GraphContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 10px; /* 스크롤바 공간 확보 */
  
  /* 스크롤바 스타일 커스터마이징 (선택사항) */
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const ChartWrapper = styled.div`
  width: 5220px; /* 차트의 전체 너비 지정 */
  height: 400px;
`;

const data = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

function Graph() {
    return (
      <GraphContainer>
        <ChartWrapper>
          <AreaChart
            width={5220}
            height={400}
            data={data}
            margin={{
              top: 0,
              right: 0,
              left: 155,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area
              type="stepAfter"
              stepType="hv"
              dataKey="uv"
              stackId="1"
              stroke="#8884d8"
              fill="#8884d8"
            />
            <Area
              type="stepAfter"
              stepType="hv"
              dataKey="pv"
              stackId="1"
              stroke="#8884d8"
              fill="#ff8787"
            />
            <Area
              type="stepAfter"
              stepType="hv"
              dataKey="amt"
              stackId="1"
              stroke="#8884d8"
              fill="#96f1f2"
            />
          </AreaChart>
        </ChartWrapper>
      </GraphContainer>
    );
  }
  
export default Graph;
